import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { KpiFavorite } from 'app/interfaces/kpi-favorite.interface';
import { KpiFavoritesService } from 'app/services/kpi-favorites.service';

/**
 * "Favorites" dropdown applying / renaming / deleting a saved KPI selection, meant to sit
 * on its own in the toolbar, away from the star which saves the selection.
 *
 * It only reads and drives the KpiFavoritesService instance provided by its host, which is
 * also where the host listens for the selection to apply, through favoriteApplied$.
 */
@Component({
  selector: 'app-kpi-favorites-menu',
  templateUrl: './kpi-favorites-menu.component.html',
  styleUrls: ['./kpi-favorites-menu.component.scss'],
  imports: [MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule, TranslocoPipe],
})
export class KpiFavoritesMenuComponent {
  protected favoritesService = inject(KpiFavoritesService);

  /**
   * The translation key telling why the favorite is greyed out and can't be applied,
   * empty for a favorite the current contract can display.
   */
  tooltipKeyFor(favorite: KpiFavorite): string {
    return this.favoritesService.isApplicable(favorite) ? '' : 'FAVORITE_HAS_NO_AVAILABLE_KPI';
  }
}
